import React, { Component } from 'react'
import { connect } from 'react-redux'
import { pushNavHistory, restoreComplete } from '../store/actions'
import Device from '../../../devices/device'
import './_styles.scss'
import Submenu from '../Partidos/Components/SubmenuFases'
import CardBlue from './Components/CardBlue'
import Utils from '../../../utils/Utils'
import Translator from '../../../requests/apa/Translator'
import getStatistics from './getStatistics'
import { getNodeCode, sendMetricSelectContent, sendMetricViewItem } from '../utils'
import { MAIN_MENU } from '../constants'

class EstadisticasJuegos extends Component {
    constructor (props) {
        super(props)
        this.state = {
            phases: [],
            activePhase: null,
            phaseData: {},
            groupFilterPerPhase: {}  // recuerda el grupo activo de cada fase independientemente
        }

        this.keys = Device.getDevice().getKeys()
        this.contentEl = null
        const code = getNodeCode()
        const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
        this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    }

    componentDidMount () {
        const { pendingRestore, sectionId } = this.props
        const restoreEntry = pendingRestore && pendingRestore.section === sectionId
            ? pendingRestore
            : null

        this.fetchPhases(restoreEntry)
    }

    componentWillUnmount () {
        // Si pendingRestore está activo, el desmontaje fue causado por un BACK
        // a otra sección → no empujar al historial para evitar el loop
        if (this.props.pendingRestore) return

        const { activePhase, phaseData, groupFilterPerPhase } = this.state
        const currentData = phaseData[activePhase] || {}
        this.props.pushNavHistory({
            section: this.props.sectionId,
            activePhase,
            activeGroup: currentData.activeGroup || null,
            groupFilterPerPhase
        })

        const mainMenu = document.querySelector('.main-menu')
        if (mainMenu) {
            mainMenu.style.marginTop = '0'  
        }
    }

    componentDidUpdate(prevProps) {
        const mainMenu = document.querySelector('.main-menu')
        if (mainMenu) {
            if (this.props.headerHidden) {
                mainMenu.style.marginTop = '4.27rem'//64px
            } else {
                mainMenu.style.marginTop = '0'
            }
        }
        const { pendingRestore, sectionId } = this.props
        if (
            pendingRestore &&
            pendingRestore !== prevProps.pendingRestore &&
            pendingRestore.section === sectionId
        ) {
            this.applyRestore(pendingRestore)
        }
    }

    handlePhaseChange =  (steps) => {
        const { phases, activePhase, phaseData, groupFilterPerPhase } = this.state
        if (!phases.length) return
        
        const currentData = phaseData[activePhase] || {}
        const currentGroup = currentData.activeGroup
        
        // Guardar el grupo actual de la fase que se abandona
        const savedFilters = { ...groupFilterPerPhase, [activePhase]: currentGroup }
        
        const idx = phases.findIndex(function (p) { return p.id === activePhase })
        const newIdx = ((idx + steps) % phases.length + phases.length) % phases.length
        const newPhaseId = phases[newIdx].id
        
        // Guardar estado actual en Redux antes de cambiar
        this.props.pushNavHistory({
            section: this.props.sectionId,
            activePhase,
            activeGroup: currentGroup || null,
            groupFilterPerPhase
        })
        
        // Restaurar el grupo de la nueva fase (o el primero si nunca se visitó)
        const newPhaseData = phaseData[newPhaseId] || {}
        const newPhaseSubGroups = newPhaseData.subGroups || []
        const restoredGroup = savedFilters[newPhaseId] || (newPhaseSubGroups[0] && newPhaseSubGroups[0].id) || null
        
        this.setState(prevState => ({
            activePhase: newPhaseId,
            groupFilterPerPhase: savedFilters,
            phaseData: {
                ...prevState.phaseData,
                [newPhaseId]: {
                    ...(prevState.phaseData[newPhaseId] || {}),
                    activeGroup: restoredGroup
                }
            }
        }), () => {
            if (!this.state.phaseData[newPhaseId] || !this.state.phaseData[newPhaseId].subGroups) {
                this.fetchPhaseData(newPhaseId)
            }
        })

        // Métricas
        const data = this.state.phaseData[newPhaseId]
        if (!data) return

        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabData = phases.find(phase => phase.id === newPhaseId)
        const parentTabLabel = parentTabData && parentTabData.label
        const childTabData = newPhaseSubGroups.find(group => group.code === restoredGroup)
        const childTabLabel = childTabData && childTabData.label

        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
        sendMetricViewItem(mainMenuLabel, parentTabLabel, childTabLabel, parentTabLabel)
    }

    handleGroupChange = (steps) => {
        const { activePhase, phaseData, groupFilterPerPhase } = this.state
        const currentData = phaseData[activePhase] || {}
        const subGroups = currentData.subGroups || []
        if (!subGroups.length) return

        const safeCurrent = currentData.activeGroup || (subGroups[0] && subGroups[0].id)
        const idx = subGroups.findIndex((g) => g.id === safeCurrent)
        const baseIdx = idx >= 0 ? idx : 0
        const newIdx = Math.max(0, Math.min(baseIdx + steps, subGroups.length - 1))
        const newGroupId = subGroups[newIdx].id
        if (newGroupId === safeCurrent) return

        // Guardar estado actual en Redux antes de cambiar
        this.props.pushNavHistory({
            section: this.props.sectionId,
            activePhase,
            activeGroup: safeCurrent,
            groupFilterPerPhase
        })

        this.setState(prevState => ({
            phaseData: {
                ...prevState.phaseData,
                [activePhase]: { ...currentData, activeGroup: newGroupId }
            },
            groupFilterPerPhase: {
                ...prevState.groupFilterPerPhase,
                [activePhase]: newGroupId
            }
        }))

        // Métricas
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabData = this.state.phases.find(phase => phase.id === activePhase)
        const parentTabLabel = parentTabData && parentTabData.label
        const childTabLabel = subGroups[newIdx].label

        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
        sendMetricViewItem(mainMenuLabel, parentTabLabel, childTabLabel, childTabLabel)
    }

    handleGroupSelect = (tab) => {
        if (!tab) return

        const { activePhase, phaseData, groupFilterPerPhase } = this.state
        const currentData = phaseData[activePhase] || {}
        const safeCurrent = currentData.activeGroup

        if (safeCurrent === tab.id) return

        // Guardar estado actual en Redux antes de cambiar
        this.props.pushNavHistory({
            section: this.props.sectionId,
            activePhase,
            activeGroup: safeCurrent || null,
            groupFilterPerPhase
        })

        this.setState(prevState => ({
            phaseData: {
                ...prevState.phaseData,
                [activePhase]: { ...currentData, activeGroup: tab.id }
            },
            groupFilterPerPhase: {
                ...prevState.groupFilterPerPhase,
                [activePhase]: tab.id
            }
        }))
    }

    applyRestore = (entry) => {
        const restoredPhase = entry.activePhase || null
        const restoredGroup = entry.activeGroup || null
        const restoredFiltersPerPhase = entry.groupFilterPerPhase || {}

        this.setState({
            activePhase: restoredPhase,
            groupFilterPerPhase: restoredFiltersPerPhase,
            phaseData: {
                ...this.state.phaseData,
                [restoredPhase]: {
                    ...(this.state.phaseData[restoredPhase] || {}),
                    activeGroup: restoredGroup
                }
            }
        }, () => {
            // Posicionar el foco en el elemento correcto
            setTimeout(() => {
                const contentEl = this.contentEl
                if (!contentEl) return

                const hasSubGroups = restoredGroup !== null
                const selector = hasSubGroups
                    ? '.estadisticas-juegos__card-blue-submenu-wrap .focusable'
                    : '.estadisticas-juegos__card-blue-menu-wrap .focusable'
                const target = contentEl.querySelector(selector)
                if (target) target.focus()
            }, 0)
            
            this.props.restoreComplete()
        })
    }

    getPhases () {
        return [
            { id: 'offensive', label: Utils.cutPlayerString(Translator.get('eventodeportivo_estadisticajuegos_tabs_texto_tab1'), 19) },
            { id: 'defensive', label: Utils.cutPlayerString(Translator.get('eventodeportivo_estadisticajuegos_tabs_texto_tab2'), 19) },
            { id: 'goalkeeping', label: Utils.cutPlayerString(Translator.get('eventodeportivo_estadisticajuegos_tabs_texto_tab3'), 19) },
            { id: 'foulsAndCards', label: Utils.cutPlayerString(Translator.get('eventodeportivo_estadisticajuegos_tabs_texto_tab4'), 19) }
        ]
    }

    getTopTitleByCode (code) {
        const topTitleByCode = {
            goals: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_topgoles',
            assists: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_toppasesgol',
            shots: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_toptirostotales',
            shotsOnGoal: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_toptirosporteria',
            dribblesSuccess: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_topregates',
            passesTotal: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_toppases',
            offsides: 'eventodeportivo_estadisticajuegos_ofensiva_texto_titulo_topfueradejuego',
            interceptions: 'eventodeportivo_estadisticajuegos_defensiva_texto_titulo_topintercepciones',
            tacklesWon: 'eventodeportivo_estadisticajuegos_defensiva_texto_titulo_topentradasganadas',
            saves: 'eventodeportivo_estadisticajuegos_portero_texto_titulo_topparadas',
            cleanSheets: 'eventodeportivo_estadisticajuegos_portero_texto_titulo_topporteriacero',
            fouls: 'eventodeportivo_estadisticajuegos_faltas_texto_titulo_faltascometidas',
            foulsAgainst: 'eventodeportivo_estadisticajuegos_faltas_texto_titulo_faltasrecibidas',
            yellow_cards: 'eventodeportivo_estadisticajuegos_faltas_texto_titulo_tarjetasamarillas'
        }

        const translationKey = code ? topTitleByCode[code] : null
        const translatedTitle = translationKey ? Translator.get(translationKey) : null
        const safeTitle = translatedTitle || ''
        return Utils.cutPlayerString(safeTitle, 34)
    }

    getPhaseSubGroups () {
        const { phaseData } = this.state

        return Object.keys(phaseData).reduce((acc, phaseKey) => {
            const subGroups = phaseData[phaseKey] && Array.isArray(phaseData[phaseKey].subGroups)
                ? phaseData[phaseKey].subGroups
                : []

            acc[phaseKey] = subGroups.reduce((groupsAcc, group) => {
                const code = group && group.id
                if (!code) return groupsAcc

                groupsAcc[code] = this.getTopTitleByCode(code)
                return groupsAcc
            }, {})

            return acc
        }, {})
    }

    fetchPhases (restoreEntry) {
        const phases = this.getPhases()
        const firstPhaseId = restoreEntry
            ? restoreEntry.activePhase
            : (phases[0] ? phases[0].id : null)
    
        this.setState({ phases, activePhase: firstPhaseId }, () => {
            if (firstPhaseId) {
                this.fetchPhaseData(firstPhaseId).then(() => {
                    if (restoreEntry) {
                        this.applyRestore(restoreEntry)
                    } else {
                        setTimeout(() => {
                            if (!this.contentEl) return
                            const target = this.contentEl.querySelector('.estadisticas-juegos__card-blue-menu-wrap .focusable')
                            if (target) target.focus()
                        }, 0)
                    }
                })
            }
        })
    }

    getNormalizedPhaseData (statisticsData) {
        const phaseKeyMap = {
            offensive: 'offensive',
            defensive: 'defensive',
            goalkeeping: 'goalkeeping',
            foulsAndCards: 'foulsAndCards'
        }

        return Object.keys(phaseKeyMap).reduce((acc, phaseKey) => {
            const apiPhaseKey = phaseKeyMap[phaseKey]
            const rawApiPhaseData = apiPhaseKey && statisticsData ? statisticsData[apiPhaseKey] : []
            const safePhaseData = Array.isArray(rawApiPhaseData) ? rawApiPhaseData : []

            const subGroups = safePhaseData.map((item, index) => {
                const code = item && item.code ? item.code : `group-${index}`
                const name = item && item.name ? item.name : code

                return {
                    ...item,
                    id: code,
                    label: name,
                }
            })

            const activeGroup = subGroups[0] ? subGroups[0].id : null
            const activeGroupItem = subGroups.find((group) => group.id === activeGroup)

            acc[phaseKey] = {
                subGroups,
                activeGroup,
            }

            return acc
        }, {})
    }

    async fetchPhaseData (phaseId) {
        const statisticsData = await getStatistics(this.idLeague)
        const normalizedPhaseData = this.getNormalizedPhaseData(statisticsData)
        const data = normalizedPhaseData[phaseId] || null
        if (!data) return

        this.setState(function (prevState) {
            const mergedPhaseData = Object.keys(normalizedPhaseData).reduce((acc, key) => {
                const previousPhaseData = prevState.phaseData[key] || {}
                acc[key] = {
                    ...normalizedPhaseData[key],
                    activeGroup: previousPhaseData.activeGroup || normalizedPhaseData[key].activeGroup
                }
                return acc
            }, {})

            return {
                phaseData: {
                    ...prevState.phaseData,
                    ...mergedPhaseData,
                    [phaseId]: {
                        ...data,
                        activeGroup: (prevState.phaseData[phaseId] && prevState.phaseData[phaseId].activeGroup) || data.activeGroup
                    }
                }
            }
        })

        //Métricas
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabData = this.state.phases.find(phase => phase.id === phaseId)
        const parentTabLabel = parentTabData && parentTabData.label
        const childTabData = data.subGroups.find(group => group.id === data.activeGroup)
        const childTabLabel = childTabData && childTabData.label

        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
        sendMetricViewItem(mainMenuLabel, parentTabLabel, childTabLabel, parentTabLabel)
    }

    isZeroGoalValue = (playerItem) => {
        const value = playerItem && playerItem.player ? playerItem.player.value : null
        if (value === null || value === undefined) return false

        const normalizedValue = String(value).trim()
        if (normalizedValue === '') return false

        const numericValue = Number(normalizedValue)
        return !Number.isNaN(numericValue) && numericValue === 0
    }

    getRankingTopWithAlphabeticalFallback = (rankingTop) => {
        const safeRankingTop = Array.isArray(rankingTop) ? rankingTop : []
        const topTenPlayers = safeRankingTop.slice(0, 10)

        if (!topTenPlayers.length) return safeRankingTop

        const allTopTenWithZeroGoals = topTenPlayers.every((playerItem) => this.isZeroGoalValue(playerItem))

        if (!allTopTenWithZeroGoals) return safeRankingTop

        const getPlayerName = (playerItem) => {
            if (!playerItem || !playerItem.player || !playerItem.player.name) return ''
            return String(playerItem.player.name)
        }

        const sortedTopTen = topTenPlayers
            .slice()
            .sort((playerA, playerB) => getPlayerName(playerA).localeCompare(getPlayerName(playerB), 'es', { sensitivity: 'base' }))
            .map((playerItem, index) => ({
                ...playerItem,
                position: index + 1,
            }))

        return [...sortedTopTen, ...safeRankingTop.slice(10)]
    }

    render () {
        const phases = this.state.phases
        const activePhase = this.state.activePhase
        const phaseData = this.state.phaseData
        const phasesTopTitle = this.getPhaseSubGroups()
        const currentData = phaseData[activePhase] || {}
        const filters = currentData.subGroups || []
        const activeFilter = currentData.activeGroup || (filters[0] && filters[0].id) || null
        const activeFilterItem = filters.find((item) => item.id === activeFilter) || filters[0] || null
        const rankingTop = activeFilterItem && activeFilterItem.ranking || []
        const shouldSortRankingTop = rankingTop.slice(0, 10).length > 0 && rankingTop.slice(0, 10).every((playerItem) => this.isZeroGoalValue(playerItem))
        const phaseTitles = activePhase && phasesTopTitle[activePhase] ? phasesTopTitle[activePhase] : {}
        const dynamicTopTitle = (activeFilter && phaseTitles[activeFilter]) || (activeFilterItem && activeFilterItem.label) || ''

        const tabNavDown = filters.length > 0
            ? { 'data-sn-down': '.estadisticas-juegos__card-blue-submenu-wrap .focusable' }
            : {}

        const filterNavUp = { 'data-sn-up': '.estadisticas-juegos__card-blue-menu-wrap  .focusable' }

        const { headerHidden } = this.props

        return (
            <div className='estadisticas-juegos__content' ref={(el) => { this.contentEl = el }}>
                <div className='estadisticas-juegos__card-blue-menu-wrap'>
                    <Submenu
                        tabs={phases}
                        activeTab={activePhase}
                        onNavigate={this.handlePhaseChange}
                        itemDataOptions={tabNavDown}
                        classNames={{
                            tab: 'estadisticas-juegos__tabs-phases',
                            active: 'estadisticas-juegos__item-active-not-focused',
                        }}
                    />
                </div>
                <CardBlue
                    filters={filters}
                    activeTab={activeFilter}
                    topTitle={dynamicTopTitle}
                    onTabChange={this.handleGroupChange}
                    onTabSelect={this.handleGroupSelect}
                    itemDataOptions={filterNavUp}
                    rankingTop={shouldSortRankingTop ? this.getRankingTopWithAlphabeticalFallback(rankingTop) : rankingTop}
                />
            </div>
        )
    }
}

const mapStateToProps = function (state) {
    return {
        pendingRestore: state.pendingRestore,
        headerHidden: state.headerHidden
    }
}

const mapDispatchToProps = function (dispatch) {
    return {
        pushNavHistory: function (entry) { dispatch(pushNavHistory(entry)) },
        restoreComplete: function () { dispatch(restoreComplete()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EstadisticasJuegos)



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/index.jsx